// FIXME ДОЛЖЕН БЫТЬ ТАКОЙ ПОРЯДОК
// eslint-disable-next-line
import './base.css'
import { router } from './router'

import './style/main.less'

import { RouterProvider } from '@tanstack/react-router'
import { NotificationProvider } from 'components/extend/Notification'
import { Notifications } from 'components/extend/Notifications'
import { ModalProvider } from 'components/ModalProvider'
import { YandexMetrikaProvider } from 'components/YandexMetrikaProvider'
import { CookieBannerChecker } from 'layouts/MainLayout/CookieBanner/CookieBannerChecker'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { store } from 'store/store'

import { FeatureFlagsPanel } from './components/FeatureFlagsPanel'
import { MapProvider } from './components/Map'
import VersionChecker from './components/VersionChecker'
import { UpdatedSupportChat } from './layouts/MainLayout/SupportChat/SupportChat'
import { OrderCreateProvider } from './modules/order/pages/OrderCreateRoute/OrderCreateProvider'

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <Provider store={store}>
    <HelmetProvider>
      <MapProvider>
        <NotificationProvider>
          <OrderCreateProvider>
            <ModalProvider>
              <YandexMetrikaProvider>
                <RouterProvider router={router} />
              </YandexMetrikaProvider>
            </ModalProvider>
          </OrderCreateProvider>
          <Notifications />
          <CookieBannerChecker />
          <UpdatedSupportChat />
          <VersionChecker />
          <FeatureFlagsPanel />
        </NotificationProvider>
      </MapProvider>
    </HelmetProvider>
  </Provider>
)
